/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { AaiChannelItem } from '../../asyncapi/models/AaiChannelItem';
import { AaiDocument } from '../../asyncapi/models/AaiDocument';
import { AbstractCommand } from '../AbstractCommand';
import { LoggerCompat } from '../../compat/LoggerCompat';
import { Document } from '../../core/models/Document';

/**
 * A command used to create a new channel item in aa AsyncAPI document.
 * @author laurent.broudoux@gmail.com
 * @param {string} newChannel
 * @class
 * @extends AbstractCommand
 */
export class NewChannelCommand extends AbstractCommand {
    public _newChannel : string;

    public _channelExisted : boolean;

    public _emptyChannels : boolean;

    public constructor(newChannel? : any) {
        if(((typeof newChannel === 'string') || newChannel === null)) {
            let __args = arguments;
            super();
            if(this._newChannel===undefined) this._newChannel = null;
            if(this._channelExisted===undefined) this._channelExisted = false;
            if(this._emptyChannels===undefined) this._emptyChannels = false;
            if(this._newChannel===undefined) this._newChannel = null;
            if(this._channelExisted===undefined) this._channelExisted = false;
            if(this._emptyChannels===undefined) this._emptyChannels = false;
            (() => {
                this._newChannel = newChannel;
            })();
        } else if(newChannel === undefined) {
            let __args = arguments;
            super();
            if(this._newChannel===undefined) this._newChannel = null;
            if(this._channelExisted===undefined) this._channelExisted = false;
            if(this._emptyChannels===undefined) this._emptyChannels = false;
            if(this._newChannel===undefined) this._newChannel = null;
            if(this._channelExisted===undefined) this._channelExisted = false;
            if(this._emptyChannels===undefined) this._emptyChannels = false;
        } else throw new Error('invalid overload');
    }

    /**
     * 
     * @param {Document} document
     */
    public execute(document : Document) {
        LoggerCompat.info("[NewChannelCommand] Executing.");
        let adoc : AaiDocument = <AaiDocument>document;
        if(adoc.channels != null && /* isEmpty */(Object.keys(adoc.channels).length == 0)) {
            this._emptyChannels = true;
        }
        if(this.isNullOrUndefined(/* get */((m,k) => m[k]===undefined?null:m[k])(adoc.channels, this._newChannel))) {
            let channelItem : AaiChannelItem = adoc.createChannelItem(this._newChannel);
            adoc.addChannelItem(channelItem);
            this._channelExisted = false;
        } else {
            this._channelExisted = true;
        }
    }

    /**
     * 
     * @param {Document} document
     */
    public undo(document : Document) {
        LoggerCompat.info("[NewChannelCommand] Reverting.");
        let adoc : AaiDocument = <AaiDocument>document;
        if(this._channelExisted) {
            LoggerCompat.info("[NewChannelCommand] channel already existed, nothing done so no rollback necessary.");
            return;
        }
        if(this._emptyChannels) {
            /* clear */(obj => { for (let member in obj) delete obj[member]; })(adoc.channels);
        } else {
            /* remove */(map => { let deleted = adoc.channels[this._newChannel];delete adoc.channels[this._newChannel];return deleted;})(adoc.channels);
        }
    }
}
NewChannelCommand["__class"] = "io.apicurio.datamodels.cmd.commands.NewChannelCommand";
NewChannelCommand["__interfaces"] = ["io.apicurio.datamodels.cmd.ICommand"];




